/**
 * 用户
 */

// 模块文件配置
const { VITE_APP_AFTER } = import.meta.env
const prefix = VITE_APP_AFTER
export default [
  // 用户登录
  { name: 'userLogin', url: `${prefix}/open/login`, method: 'post' },
]
